import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import {
  DepositStatus,
  OrderReservationType,
  OrderStatus,
  PaymentMethod,
  PurchaseStatus,
  YesNo,
} from 'interfaces';

export type OrderReservation = {
  order_reservation_id?: number; // 오더/예약 idx
  shop_information_id?: number; // 매장 idx
  order_id?: number; // 주문 idx
  coupon_id?: number; // 쿠폰 idx
  user_id?: number; // 유저 idx
  order_status?: typeof OrderStatus; // 주문상태
  order_time_status?: string; // 오더/예약 시간 상태
  menu?: { [key: string]: Record<string, any> }; // 메뉴정보
  payment_date?: number; // 결제일
  deposit_status?: (typeof DepositStatus)[keyof typeof DepositStatus]; // 입금상태
  purchase_status?: (typeof PurchaseStatus)[keyof typeof PurchaseStatus]; // 구매상태
  payment_method?: (typeof PaymentMethod)[keyof typeof PaymentMethod]; // 결제수단
  is_present?: (typeof YesNo)[keyof typeof YesNo]; // 선물여부
  type?: (typeof OrderReservationType)[keyof typeof OrderReservationType]; // 타입
  group_id?: string; // 그룹 idx
  num?: number; // 수량
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] OrderReservation
   * --
   */
  getOrderReservations: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_ORDER_RESERVATION, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] OrderReservation
   * --
   */
  getOrderReservation: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_ORDER_RESERVATION, {
        order_reservation_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] OrderReservation
   * --
   */
  createOrderReservation: async (body: OrderReservation) => {
    try {
      const res = await $http.post(APIConstant.CREATE_ORDER_RESERVATION, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] OrderReservation
   * --
   */
  updateOrderReservation: async (body: OrderReservation) => {
    try {
      const { order_reservation_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_ORDER_RESERVATION, {
        order_reservation_id: order_reservation_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] OrderReservation
   * --
   */
  deleteOrderReservation: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_ORDER_RESERVATION, {
        order_reservation_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
